import { useState } from 'react';
import { FocusStats } from '../features/focus/FocusStats.js';
import { PomodoroTimer } from '../features/focus/PomodoroTimer.js';
import { Stopwatch } from '../features/focus/Stopwatch.js';

type Aba = 'pomo' | 'stopwatch' | 'stats';

const ABAS: Array<{ id: Aba; label: string }> = [
  { id: 'pomo', label: 'Pomo' },
  { id: 'stopwatch', label: 'Cronômetro' },
  { id: 'stats', label: 'Estatísticas' },
];

/**
 * Tela de Foco (spec 9.3).
 *
 * As tres abas compartilham a MESMA sessao no servidor — nao existe um
 * cronometro por aba. Trocar de aba e so trocar a lente sobre o mesmo estado,
 * o que evita o caso em que o usuario acredita ter dois relogios rodando.
 */
export function Focus() {
  const [aba, setAba] = useState<Aba>('pomo');

  return (
    <div className="mx-auto flex max-w-2xl flex-col items-center gap-6 p-4">
      <header className="flex w-full items-center justify-between">
        <h1 className="font-display text-lg font-semibold">Foco</h1>

        <div className="flex gap-1" role="tablist" aria-label="Modo de foco">
          {ABAS.map((item) => (
            <button
              key={item.id}
              type="button"
              role="tab"
              aria-selected={item.id === aba}
              onClick={() => setAba(item.id)}
              className={[
                'min-h-touch rounded-sm px-3 text-sm transition-colors duration-150',
                item.id === aba
                  ? 'bg-brand-blue-soft font-medium text-brand-blue'
                  : 'text-text-mut hover:bg-surface-2',
              ].join(' ')}
            >
              {item.label}
            </button>
          ))}
        </div>
      </header>

      {aba === 'pomo' ? <PomodoroTimer /> : null}
      {aba === 'stopwatch' ? <Stopwatch /> : null}
      {aba === 'stats' ? <FocusStats /> : null}
    </div>
  );
}
